import { render, staticRenderFns } from "./wdsc.vue?vue&type=template&id=16cef949&scoped=true&"
import script from "./wdsc.vue?vue&type=script&lang=js&"
export * from "./wdsc.vue?vue&type=script&lang=js&"
import style0 from "./wdsc.vue?vue&type=style&index=0&id=16cef949&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cef949",
  null
  
)

export default component.exports